import { ReactNode } from 'react'

interface PreLoginCardProps {
  children: ReactNode
}

/**
 * PreLoginCard - Card container for pre-authentication forms
 *
 * Provides a white card with rounded corners and shadow that matches
 * the landing page feature cards styling.
 */
const PreLoginCard = ({ children }: PreLoginCardProps) => {
  return (
    <div
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        padding: '48px',
        borderRadius: '16px',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        maxWidth: '480px',
        width: '100%'
      }}
    >
      {children}
    </div>
  )
}

export default PreLoginCard
